module.exports = __webpack_public_path__ + "static/media/prismport-2.896861af.jpg";